import { DateObject } from 'react-multi-date-picker'
import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'

export function FormJsonToShamsiDay(value) {
    if (!value) return ''
    
    try {
        // پارس کردن تاریخ ISO به صورت دستی
        const isoRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{3}))?Z$/;
        const match = value.match(isoRegex);
        
        if (!match) {
            console.error('فرمت تاریخ ISO نامعتبر است:', value);
            return '';
        }
        
        // استخراج اجزای تاریخ و زمان
        const [, year, month, day, hour, minute, second] = match;
        
        // ساخت آبجکت DateObject مستقیماً از اعداد استخراج شده
        // ساخت یک تاریخ گرگوری با مقادیر مشخص (بدون تبدیل به Date جاوااسکریپت)
        const date = new DateObject({
            year: parseInt(year),
            month: parseInt(month),
            day: parseInt(day),
            hour: parseInt(hour),
            minute: parseInt(minute),
            second: parseInt(second),
            format: "YYYY-MM-DD HH:mm:ss",
            // تنظیم تقویم به گرگوری که با فرمت ISO سازگار است
            calendar: "gregorian"
        });
        
        // تبدیل به منطقه زمانی تهران (اضافه کردن 3:30 ساعت)
        // ایران 3:30 ساعت جلوتر از UTC است
        date.add(3, "hour").add(30, "minute");
        
        // تبدیل به تقویم شمسی
        const persianDate = date.convert(persian, persian_fa);
        
        // دریافت نام روز هفته
        const weekDay = persianDate.weekDay.name;
        
        // بازگرداندن تاریخ شمسی با فرمت دلخواه
        return weekDay + '، ' + persianDate.format('YYYY/MM/DD');
    } catch (error) {
        console.error('خطا در تبدیل تاریخ:', error);
        return '';
    }
}
